import { render } from "./icon.vue?vue&type=template&id=5a9cd31d"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/horizontal/icon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a9cd31d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a9cd31d', __exports__)) {
    console.log('reload')
    api.reload('5a9cd31d', __exports__)
  }
  
  module.hot.accept("./icon.vue?vue&type=template&id=5a9cd31d", () => {
    console.log('re-render')
    api.rerender('5a9cd31d', render)
  })

}


export default __exports__